import React, { Component } from 'react';
import PropTypes from 'prop-types';

const rtl = (ComponentToWrap) => {
  return class extends Component {
    static contextTypes = {
      isRtl: PropTypes.bool
    }

    render() {
      const { isRtl } = this.context
      return (
        <ComponentToWrap {...this.props} isRtl={isRtl} />
      )
    }
  }
}

export default rtl;



// WEBPACK FOOTER //
// ./src/components/RTLProvider/rtl.jsx